import React, { useState, useEffect } from "react";
import { backendApi } from "../../api/apiService";
import { IoMdCloseCircle } from "react-icons/io";
import { FaCheckCircle, FaRupeeSign } from "react-icons/fa";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScheduleInterviewPopup from "../schedule/scheduleInterviewPopup";
import ShortListPopup from "../leads/shortListPopup";
import { useNavigate } from "react-router-dom";
import Pagination from "react-js-pagination";
import $ from "jquery";
import {
  FiSearch,
  FiMail,
  FiPhone,
  FiUsers,
  FiCalendar,
  FiMapPin,
} from "react-icons/fi";
import { MdOutlineCurrencyRupee } from "react-icons/md";
import { FaRegAddressCard } from "react-icons/fa";
import { GiSkills } from "react-icons/gi";
import { FaRegCalendarAlt } from "react-icons/fa";
export default function RecentUploadFiles() {
  const roleId = parseInt(window.localStorage.getItem("role_id"));
  const isAdminRole = roleId === 1 || roleId === 2 || roleId === 5;
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState(1);
  const [candidateData, setCandidateData] = useState([]);
  const [searchParams, setSearchParams] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [selectedResume, setSelectedResume] = useState(null);
  const [docLink, setDocLink] = useState("");
  const [isPdf, setIsPdf] = useState(false);
  const [scheduleInterview, setScheduleInterview] = useState(false);
  const [candidateId, setCandidateId] = useState("");
  const [showShortList, setShowShortList] = useState(false);
  const [totalCount, setTotalCount] = useState();
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("JobSearchMenu").classList.add("active");
    }, 500);
    $(window).scroll(function () {
      var yOffset = $(window).scrollTop();
      var headerHeight2 = $("#resume-section").height();
      if (yOffset >= headerHeight2 - 300) {
        $("#resume-section").css("top", "65px");
      } else {
        $("#resume-section").css("top", "auto");
      }
    });
    searchCandidates();
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      searchCandidates();
    }
  };
  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    return new Date(dateString).toLocaleDateString("en-GB", options);
  }
  const closePopup = () => {
    setScheduleInterview(false);
  };
  const getCandidatesResume = (name) => {
    return new Promise((resolve, reject) => {
      var req = {
        functionName: "searchCandidate",
        site_id: localStorage.getItem("siteId"),
        searchParams: name,
      };
      backendApi(req).then((response) => {
        if (response.success === "1") {
          resolve(response.dataListing);
          return response.dataListing;
          // setCandidateData(response.dataListing);
          // setTotalCount(response?.total);
        } else {
          reject([]);
          return [];
        }
      });
    });
  };
  const handleResumeSelect = (attachmentId) => {
    if (attachmentId) {
      const selectedResumeObject = attachments.find(
        (attachment) => attachment.id == attachmentId
      );
      setSelectedResume(selectedResumeObject);
      setDocLink(selectedResumeObject.file_link);
      setIsPdf(selectedResumeObject.file_link.toLowerCase().endsWith(".pdf"));
    } else {
      setSelectedResume(null);
    }
  };
  const candidateInterview = (id) => {
    setCandidateId(id);
    setScheduleInterview(true);
  };

  const searchCandidates = (offset = 0) => {
    const api = {
      // functionName: "commonSearch",
      // searchKeyword: searchParams,
      // offset: offset,
      // site_id: localStorage.getItem("siteId"),
      // max: "25",
      functionName: "LatestCandidateList",
      site_id: localStorage.getItem("siteId"),
      searchParam: searchParams,
      offset: offset,
    };
    backendApi(api).then((response) => {
      // console.log("🚀 ~ backendApi ~ response:", response);
      if (response.success === "1") {
        let sortedArry = response.candidatedata.map((obj) => obj._source);
        // setSearchList(sortedArry);
        console.log(sortedArry, "sortedArry");
        setCandidateData(response?.candidatedata);
        //setTotalCount(response?.total);
        setTotalCount(response?.candidatedata.length);
        // setTotalCount(response.count);
      }
    });
  };

  const searchCandidates1 = () => {
    // if (searchParams === "") {
    //   toast.warn("Please enter keywords to search relevant candidates", {
    //     containerId: "Z",
    //   });
    //   return false;
    // }
    var req = {
      functionName: "searchCandidate",
      site_id: localStorage.getItem("siteId"),
      searchParams: searchParams,
    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        setCandidateData(response.dataListing);
        setTotalCount(response?.total);
      } else {
        setTotalCount(0);
        toast.warn("Wrong username or password", { containerId: "D" });
        return false;
      }
    });
  };
  const viewResume = async (candidate) => {
    const candidates = await getCandidatesResume(candidate.full_name);
    const { attachments } = candidates.filter((o) => o.id === candidate.id)[0];
    setSelectedResume(null);
    if (attachments.length > 0) {
      setAttachments(attachments);
      setSelectedResume(attachments[0]);
      setDocLink(attachments[0].file_link);
      setIsPdf(attachments[0].file_link.toLowerCase().endsWith(".pdf"));
    } else {
      toast.warn("No attachments for the selected Candidate", {
        containerId: "Z",
      });
    }
  };
  const Cancel = () => {
    setShowShortList(false);
  };
  const showShortListClick = (id) => {
    setCandidateId(id);
    setShowShortList(true);
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    var offset;
    var max;
    if (pageNumber === "1") {
      offset = "0";
      max = 10;
    } else {
      offset = parseInt(pageNumber - 1) * 25;
      max = 10;
    }
    searchCandidates(offset);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Hired":
        return "green";
      case "Rejected":
        return "red";
      case "ShortListed":
        return "blue";
      case "Applied":
        return "gold";
      case "Screened":
        return "purple";
      case "Interviewed":
        return "orange";
      case "Offer":
        return "#fff";
      default:
        return "red";
    }
  };
  const [menuClick, setMenuClick] = useState(false);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };

  return (
    <>
      {/* <div className="main-wrapper">
        <div className="top-color"></div>
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <ToastContainer
            enableMultiContainer
            containerId={"Z"}
            position="bottom-right"
            autoClose={1500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <Header
            Header="Candidates"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          /> */}

      <div className="main-container">
        <div className="row">
          <div className="col-xxl-6 col-lg-6 col-12 padding-left-change">
            <div className="d-flex align-items-center  gap-2 my-3">
              <div className="w-100">
                <div className="input-group">
                  <span className="input-group-text text-body search_group_text">
                    <FiSearch />
                  </span>
                  <input
                    type="text"
                    className="form-control search_input border"
                    placeholder="Enter Skills / Designations / Companies "
                    value={searchParams}
                    onChange={(e) => setSearchParams(e.target.value)}
                    // onKeyDown={handleKeyPress}
                  />
                  <button
                    className="btn btn-search-custome"
                    onClick={(e) => {
                      e.preventDefault();
                      searchCandidates();
                    }}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
            <div className="card main-card">
              <div className="card-body">
                <div className="d-flex flex-wrap gap-3 align-items-center  mb-3">
                  <div className="counter-text">
                    {candidateData.length > 0 ? (
                      <>
                        <span className="font-Medium ">Count:</span>
                        <span className="ms-1">{totalCount}</span>{" "}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  {totalCount > 25 && (
                    <div className="pagination_main ms-auto">
                      <Pagination
                        activePage={activePage}
                        itemsCountPerPage={25}
                        totalItemsCount={totalCount}
                        pageRangeDisplayed={5}
                        onChange={handlePageChange}
                      />
                    </div>
                  )}
                </div>
                {candidateData.length > 0 ? (
                  candidateData.map((candidate, index) => (
                    <div className="card-inner">
                      <div className="job_searchHeading">
                        <div className="job-view">
                          <h4
                            className="job-view-header search_more_view"
                            onClick={() =>
                              navigate(`/candidateprofile/${candidate.id}`, {
                                state: { from: "searchResult" },
                              })
                            }
                          >
                            {candidate.full_name}
                          </h4>
                        </div>
                        {candidate?.status ? (
                          <span
                            className="badge rounded-pill text-bg-secondary badge-edited"
                            style={{
                              backgroundColor: getStatusColor(
                                candidate?.status
                              ),
                            }}
                          >
                            Status: {candidate.status}{" "}
                            <span className="ml-1">
                              <FaCheckCircle fill={"#fff"}></FaCheckCircle>
                            </span>
                          </span>
                        ) : (
                          <span className="badge rounded-pill text-bg-secondary  badge-edited">
                            Status: Not Available{" "}
                            <span className="ml-1">
                              <IoMdCloseCircle
                                fill={"#F44336"}
                              ></IoMdCloseCircle>
                            </span>
                          </span>
                        )}
                      </div>
                      <div className="flex-result">
                        <div className="flex-sub-div">
                          <span className="label-text">
                            <FiMail className="me-1" />
                          </span>
                          <span className="font-Medium ">
                            {candidate.email_id}
                          </span>{" "}
                        </div>
                        <div className="flex-sub-div">
                          <span className="label-text">
                            <FiPhone className="me-1" />
                          </span>{" "}
                          <span className="font-Medium ">
                            {candidate.mobile_no}
                          </span>{" "}
                        </div>
                        <div className="flex-sub-div">
                          <span className="label-text">
                            <FiUsers className="me-1" />
                          </span>
                          <span className="font-Medium ">
                            {" "}
                            {candidate.total_experiance
                              ? candidate.total_experiance
                              : 0}
                          </span>
                        </div>
                        <div className="flex-sub-div">
                          <span className="label-text">
                            <MdOutlineCurrencyRupee className="me-1" />
                          </span>{" "}
                          <span className="font-Medium ">
                            {" "}
                            {candidate.ctc ? candidate.ctc : 0}
                          </span>{" "}
                        </div>
                        <div className="flex-sub-div">
                          {" "}
                          <span className="label-text">
                            <MdOutlineCurrencyRupee className="me-1" />
                          </span>{" "}
                          <span className="font-Medium ">
                            {" "}
                            {candidate.ectc ? candidate.ectc : 0}
                          </span>{" "}
                        </div>
                        <div className="flex-sub-div">
                          {" "}
                          <span className="label-text">
                            <FaRegAddressCard className="me-1" />
                          </span>{" "}
                          <span className="font-Medium ">
                            {candidate.address
                              ? candidate.address
                              : "Not Available"}
                          </span>
                        </div>
                        <div className="flex-sub-div">
                          <span className="label-text">
                            <FiCalendar className="me-1" />
                          </span>
                          <span className="font-Medium ">
                            {formatDateToCustomFormat(candidate.created_on)}
                          </span>
                        </div>
                        <div className="flex-sub-div">
                          <span className="label-text me-1">
                            <FaRegCalendarAlt />{" "}
                          </span>
                          <span className="font-Medium ">
                            {candidate.notice_period
                              ? candidate.notice_period
                              : 0}
                          </span>
                        </div>
                        <div className="flex-sub-div">
                          <span className="label-text">
                            <GiSkills />{" "}
                          </span>
                          <span className="font-Medium ">
                            {candidate.skills
                              ? candidate.skills
                              : "Not Available"}
                          </span>
                        </div>
                        <div className="flex-sub-div">
                          <span className="label-text">
                            <FiMapPin className="me-1" />
                          </span>
                          <span className="font-Medium ">
                            {candidate.location
                              ? candidate.location
                              : "Not Available"}
                          </span>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="d-flex flex-wrap align-items-center gap-3 justify-content-end">
                          {isAdminRole && (
                            <button
                              className="btn btn-btn1 btn-btn"
                              onClick={() => candidateInterview(candidate.id)}
                            >
                              Schedule Interview
                            </button>
                          )}
                          <button
                            onClick={() => viewResume(candidate)}
                            className={` btn-btn btn btn-btn2${
                              !isAdminRole ? " w-auto" : ""
                            }`}
                          >
                            View Resume
                          </button>
                          {/* {selectedResume && ( */}
                          <button
                            className=" btn-btn btn btn-btn2"
                            onClick={() => {
                              showShortListClick(candidate.id);
                            }}
                          >
                            Short List
                          </button>
                          {/* )} */}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p style={{ color: "red", marginLeft: "200px" }}>
                    No Files found
                  </p>
                )}
                {totalCount > 25 && (
                  <div className="pagination_main mb-4">
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={25}
                      totalItemsCount={totalCount}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-xxl-6 col-lg-6 col-12 padding-right-change">
            <div
              className="card main-card  crnRes resume-box"
              id="resume-section"
            >
              <div className="card-body">
                <div className="">
                  <div className="text-end mb-2 resume-short">
                    {attachments.length > 1 && (
                      <select
                        className="form-control mb-0"
                        value={selectedResume ? selectedResume.id : ""}
                        onChange={(e) => handleResumeSelect(e.target.value)}
                      >
                        <option value="">Select a Resume</option>
                        {attachments.map((attachment, index) => (
                          <option key={attachment.id} value={attachment.id}>
                            Resume-
                            {formatDateToCustomFormat(attachment.created_on)}
                          </option>
                        ))}
                      </select>
                    )}
                    {selectedResume && (
                      <button
                        className=" btn-btn btn btn-btn2"
                        onClick={() => {
                          showShortListClick(selectedResume.candidate_id);
                        }}
                      >
                        Short List
                      </button>
                    )}
                  </div>
                </div>
                {attachments.length < 1 && (
                  <div className="search_resume_bg"></div>
                )}
                <div className="" style={{ height: "400px" }}>
                  {selectedResume && (
                    <>
                      <iframe
                        title="resume"
                        src={
                          isPdf
                            ? `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(
                                docLink
                              )}`
                            : `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                                docLink
                              )}`
                        }
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        style={{ height: "inherit" }}
                      ></iframe>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {scheduleInterview && (
        <ScheduleInterviewPopup
          onClose={closePopup}
          candidateId={candidateId}
        />
      )}
      {showShortList && (
        <ShortListPopup Cancel={Cancel} candidateId={candidateId} />
      )}
    </>
  );
}
